var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiSuggestionStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8542 2.875L15.2236 3.98277C15.8209 5.77373 17.2263 7.17912 19.0172 7.7764L20.125 8.14583L19.0172 8.51527C17.2263 9.11254 15.8209 10.5179 15.2236 12.3089L14.8542 13.4167L14.4847 12.3089C13.8875 10.5179 12.4821 9.11254 10.6911 8.51527L9.58333 8.14583L10.6911 7.7764C12.4821 7.17912 13.8875 5.77373 14.4847 3.98277L14.8542 2.875ZM7.1875 11.5L7.31726 11.8891C7.91454 13.6801 9.31993 15.0855 11.1109 15.6827L11.5 15.8125L11.1109 15.9423C9.31993 16.5395 7.91454 17.9449 7.31726 19.7359L7.1875 20.125L7.05774 19.7359C6.46046 17.9449 5.05507 16.5395 3.2641 15.9423L2.875 15.8125L3.2641 15.6827C5.05507 15.0855 6.46046 13.6801 7.05774 11.8891L7.1875 11.5Z",
    fill: "#3A4861"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiSuggestionStar);
export default __webpack_public_path__ + "static/media/ai-suggestion-star.8b52e5364d4a8ffac0f60775a332e6c5.svg";
export { ForwardRef as ReactComponent };